<div id="footer">
  <div class="">
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="row px-sm-4">
          <div>
            <app-button
              id="footer-cancel"
              class="footer-button p-0 pr-2 pr-sm-5"
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              (click)="cancel()"
            ></app-button>
          </div>
          <div>
            <app-button
              id="footer-exit"
              class="footer-button p-0 pr-2"
              buttonText="Save and Exit"
              [purpose]="_buttonPurpose.Secondary"
              (focusout)="resetSaveFlag()"
              (click)="saveAndExit()"
            ></app-button>
          </div>
          <div class="ml-auto" [hidden]="step == 'step2'">
            <app-button
              id="continue"
              buttonText="Continue"
              class="footer-button p-0 pr-2"
              [purpose]="_buttonPurpose.Primary"
              [disabled]="!continueEnable"
              (click)="saveAndContinue()"
            ></app-button>
          </div>
          <div class="ml-auto" [hidden]="step == 'step1'">
            <app-button
              buttonText="Submit"
              class="footer-button p-0 pr-2"
              [purpose]="_buttonPurpose.Primary"
              (click)="submit()"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="confirmMessageData.Message != ''" class="ahe-ui-alert-modal" id="okCancelModal" role="dialog" tabindex="-1">
  <div class="modal-overlay"></div>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        {{confirmMessageData.Message}}
      </div>
      <div class="modal-footer-new">
        <app-button class="align-left" buttonText="No" [purpose]="_buttonPurpose.Secondary" data-dismiss="modal" (click)="closeConfirmModal(false)"></app-button>
        <app-button buttonText="Yes" [purpose]="_buttonPurpose.Secondary" data-dismiss="modal" (click)="closeConfirmModal(true)"></app-button>
      </div>
    </div>
  </div>
</div> -->
<div class="cancel-modal">
  <!-- basic modal -->
  <app-shared-modal
    titleText="Attention"
    [isOpen]="confirmMessageData.Message != ''"
    confirmButtonText="Yes"
    (show)="confirmMessageData.Message = ''"
    (close)="closeConfirmModal(false)"
    (cancel)="closeConfirmModal(false)"
    (confirm)="closeConfirmModal(true)"
  >
    <div class="container-fluid">
      <p>
        You are about to leave this page. Any changes made will not be saved.
      </p>
      <p>Are you sure you want to continue?</p>
    </div>
  </app-shared-modal>
</div>
<div
  *ngIf="alertMessageData.Message != ''"
  class="ahe-ui-alert-modal"
  id="alertMessageModal"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="modalHeader"
  aria-describedby="modalBody"
  tabindex="-1"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-copy alert-modal-dialog"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        (keydown.escape)="handleEscapeKey()"
      >
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="modalHeader">Alert</h2>
            <button app-button appTooltip="Close" type="button" class="close" aria-label="Close dialog" (click)="closeModal()">
              <span class="ahe-icon ahe-icon-close-white" aria-hidden="true"></span>
            </button>
          </div>
          <div class="modal-body-copy ahe-ui form-group row">
            <div
              class="ml-2"
              id="modalBody"
              style="margin: 15px"
              [innerHtml]="alertMessageData.Message"
            ></div>
          </div>
          <div class="modal-footer-new">
            <div class="okButton">
              <app-button
                buttonText="OK"
                [purpose]="_buttonPurpose.Primary"
                class="align-left"
                data-dismiss="modal"
                (click)="closeModal()"
              ></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="alertModalShow"
  class="ahe-ui-alert-modal"
  id="okModal"
  role="dialog"
  tabindex="-1"
>
  <div class="modal-overlay"></div>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        {{ alertMessage }}
      </div>
      <div class="modal-footer">
        <app-button
          class="align-left"
          buttonText="OK"
          [purpose]="_buttonPurpose.Primary"
          data-dismiss="modal"
          (click)="closeAlertModal()"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="showEmailModal"
  class="ahe-ui-alert-modal"
  id="showEmailModal"
  role="dialog"
  aria-modal="true"
  tabindex="-1"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  aria-labelledby="ConfirmationModalTitle"
  (keydown.escape)="showEmailModal = false"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-copy">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="ConfirmationModalTitle">Confirmation</h2>
              <button
                app-button
                appTooltip="Close"
                aria-label="Close dialog"
                class="close"
                data-dismiss="modal"
                type="button"
                (click)="showEmailModal = false"
              >
                <span aria-hidden="true" class="ahe-icon ahe-icon-close-white"></span>
              </button>
          </div>
          <div class="modal-body-copy ahe-ui form-group row" #emailModalBody [attr.tabindex]="isEmailModalBodyScrollable ? 0 : null" [attr.role]="isEmailModalBodyScrollable ? 'region' : null" [attr.aria-labelledby]="isEmailModalBodyScrollable ? 'ConfirmationModalTitle' : null">
            <div class="mt-1 ml-2 mb-2">
              <p>
                Your request has been submitted. <br /><br />
                Be sure to click on the refresh icon on the upper right corner
                of the page <br />
                to update the availability of your file(s).
              </p>
            </div>
            <div class="ml-2">
              <h3 class="section-heading">Review</h3>
              <div class="ahe-ui-checkbox">
                <div class="checkbox-wrapper">
                  <app-checkbox
                    id="sendMail"
                    [checked]="sendMail"
                    (change)="sendMailPref($event)"
                    value="sendMail"
                    name="sendMail"
                    [ariaLabelledBy]="'sendMailLabel'"
                  >
                  </app-checkbox>
                  <div role="status" class="sr-only">
                    {{ emailInputStateMessage }}
                  </div>
                </div>
                <span id="sendMailLabel"
                  >Send an email when test becomes available.</span
                >
              </div>
              <div class="ml-4 mt-2 ahe-ui form-group no-margin">
                <label for="userEmailId">Email:</label>
                <app-required-indicator [required]="!emailIdDisabled" [ariaHidden]="true"></app-required-indicator>
                <input
                  #EmailInput
                  type="email"
                  maxlength="120"
                  id="userEmailId"
                  class="d-block mt-2 form-control textWidth"
                  value="{{ userEmailId }}"
                  [(ngModel)]="userEmailId"
                  [disabled]="emailIdDisabled"
                  [attr.aria-invalid]="showEmailError"
                  [attr.aria-describedby]="showEmailError ? 'emailError' : null"
                  [attr.required]="sendMail ? '' : null"
                  autocomplete="email"
                  name="email"
                />
              </div>
              <div
                *ngIf="showEmailError"
                id="emailError"
                class="ml-2 mt-1"
              >
                {{ INVALID_EMAIL_MSG }}
              </div>
            </div>
          </div>
          <div class="modal-footer-new">
            <div class="okButton">
              <app-button
                buttonText="OK"
                [purpose]="_buttonPurpose.Primary"
                class="align-left"
                data-dismiss="modal"
                (click)="confirmEmail()"
              ></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
